<template>
  <h3 class="display-element form-section-headline no-label">{{ value }}</h3>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
  },
  setup() {},
};
</script>
